import { apiService } from './api.service';

export type SellableItemKind = 'core' | 'module' | 'addon';

export interface SellableItem {
  code: string;
  kind: SellableItemKind;
  category: string;
  monthlyPriceUsd: number;
  currency: string;
  unlocks: string[];
  requires?: string[];
  suggests?: string[];
  bundledInCore?: boolean;
}

export interface SellableQuantityScale {
  code: string;
  name: string;
  unit: string;
  includedQuantity: number;
  perUnitMonthlyUsd: number;
  currency: string;
  maxQuantity: number;
  /** Step-pricing fields — added by neoapi migration 0576. Optional
   *  so an old backend gracefully falls back to per-unit only. */
  baseMonthlyUsd?: number;
  stepSize?: number;
  stepPriceUsd?: number;
  requiresItemCode?: string | null;
}

export interface SellableCatalog {
  core: SellableItem;
  items: SellableItem[];
  quantityScales: SellableQuantityScale[];
  /**
   * Module code → capabilities it unlocks. Includes bundled-only
   * modules (e.g. `module.kds` shipped by Empresarial) that don't
   * appear in `items[]`. Used by /account to compute effective
   * capability ownership across owned subscription items.
   */
  moduleUnlocks?: Record<string, string[]>;
}

export const sellableCatalogService = {
  /**
   * Public, unauthenticated endpoint backing the landing builder.
   * /account reuses the same shape so the addon prices match
   * exactly what the visitor saw before signing up.
   */
  getCatalog: (): Promise<SellableCatalog> =>
    apiService.getInstance().get('/public/catalog/sellable-items'),
};
